<template>
  <transition name="fade">
    <div
      class="v-modal__overlay"
      v-if="rendered"
      @transitionend="handleOverlayTransitionend"
      @animationend="handleOverlayTransitionend"
    >
      <div
        class="v-modal__container"
        @mousedown.self.stop="handleOuterClick"
        @touchstart.self.stop="handleOuterClick"
        :class="containeClass$"
      >
        <transition name="slide-down">
          <div
            class="v-modal"
            v-show="modalVisible"
            :class="modalClass"
          >
            <slot name="header">
              <header class="v-modal__header" v-if="title">
                <h2 class="v-modal__title" v-if="title">
                  {{ title }}
                </h2>
              </header>
            </slot>
            <slot name="content">
              <div class="v-modal__content" v-if="$slots.default">
                <slot />
              </div>
            </slot>
            <div class="v-modal__footer">
              <button
                class="v-modal__close-button text-link"
                role="button"
                v-if="closeButton"
                @click.prevent="close"
              >
                {{ $t('close') }}
              </button>
              <slot name="footer" />
            </div>
          </div>
        </transition>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'VModal',
    model: {
      prop: 'visible',
      event: 'update:visible',
    },
    props: {
      visible: {
        type: Boolean,
        required: true,
      },
      outerClickClose: {
        type: Boolean,
        default: true,
      },
      lockScroll: {
        type: Boolean,
        default: true,
      },
      escapeToClose: {
        type: Boolean,
        default: true,
      },
      appendToBody: {
        type: Boolean,
        default: false,
      },
      transition: {
        type: String,
        default: 'fade',
      },
      closeButton: {
        type: Boolean,
        default: true,
      },
      title: String,
      modalClass: [Array, String],
      containerClass: [Array, String],
    },
    data() {
      return {
        rendered: false,
        overlayVisible: false,
        modalVisible: false,
        overlayTransitionendCallback: null,
        modalTransitionendCallback: null,
      };
    },
    mounted() {
      const { escapeToClose, handleEscapeKeyUp, appendToBody } = this;

      if (escapeToClose) {
        window.addEventListener('keyup', handleEscapeKeyUp);
      }

      if (appendToBody) {
        document.body.appendChild(this.$el);
      }
    },
    methods: {
      close() {
        this.$emit('close');
        this.$emit('update:visible', false);
      },
      handleOuterClick() {
        if (this.outerClickClose) {
          this.close();
        }
      },
      handleEscapeKeyUp(ev) {
        if (ev.keyCode === 27 && this.visible) {
          this.close();
        }
      },
      handleOverlayTransitionend() {
        this.$nextTick(() => {
          if (this.overlayVisible === false) {
            this.rendered = false;
          }
        });
      },
    },
    computed: {
      containeClass$() {
        const { containerClass } = this;
        let classes = [];

        if (Array.isArray(containerClass)) {
          classes = [...containerClass];
        }

        if (typeof containerClass === 'string') {
          classes.push(containerClass);
        }

        return classes;
      },
    },
    watch: {
      visible: {
        handler(visible, wasVisible) {
          if (visible && !wasVisible) {
            this.rendered = true;

            this.$nextTick(() => {
              this.modalVisible = true;
              this.overlayVisible = true;

              if (this.lockScroll) {
                document.body.classList.add('overflow-hidden');
              }

              this.$emit('opened');
            });
          } else if (!visible && wasVisible) {
            this.overlayVisible = false;
            this.modalVisible = false;

            if (this.lockScroll) {
              document.body.classList.remove('overflow-hidden');
            }

            this.$emit('closed');
          }
        },
        immediate: true,
      },
    },
  };
</script>

<style lang="scss">
  .v-modal {
    background-color: #fff;
    position: relative;
    width: calc(100% - 10px);
    min-height: 50px;
    transition: width 0.2s ease;

    &__overlay {
      position: fixed;
      left: 0;
      top: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(34, 45, 54, 0.71);
      z-index: 2000;
      opacity: 1;
      overflow: auto;
    }

    &__container {
      display: flex;
      flex-direction: column;
      width: 100%;
      min-height: 100vh;
      padding: 25px 0;
      align-items: center;
    }

    &__header {
      background-color: #e9e9e9;
    }

    &__title {
      color: #4a4a4a;
      display: block;
      margin: 0;
      padding: 23px 35px;
      font-size: 1.4rem;
      letter-spacing: 0.7px;
      font-weight: bold;
      text-transform: uppercase;
    }

    &__content {
      padding: 35px;
    }

    &__footer {
      border-top: 1px solid #cccccc;
      padding: 17px 35px;
      display: flex;
      justify-content: flex-end;
    }

    &__close-button {
      margin-right: 25px;
    }

    @media (min-width: 700px) {
      width: 585px;

      &__container {
        padding-top: 50px;
      }
    }
  }
</style>
